import React from 'react'

class SocialLink extends React.Component {

    constructor() {
        super();
    }

    render() {

        return (
            <div className='text-center pt-5'>
                <label>Connect with us</label>

                <hr />

                <div>
                    <a href="https://www.facebook.com/TupperwareSouthernAfrica" target="_blank">
                        <img className='ml-2' style={{ width: "40px" }} src={require('../../Assets/Images/facebook.png')} />
                    </a>

                    <a href="https://www.instagram.com/tupperwaresouthernafrica" target="_blank">
                        <img className='ml-4' style={{ width: "35px" }} src={require('../../Assets/Images/instagram.png')} />
                    </a>

                    <a href="https://www.youtube.com/channel/UCmi-209FdA8JLxswi_cdsPw" target="_blank">
                        <img className='ml-4' style={{ width: "35px" }} src={require('../../Assets/Images/youtube.png')} />
                    </a>
                </div>

            </div>
        );
    }
}

export default SocialLink